module.exports = __webpack_public_path__ + "img/catalogue_image1.1e53c063.jpg";